// Money for Funder Allocation is always an integer number of cents end to
// end (matches the backend) so sums/comparisons never hit float rounding -
// convert to/from dollars only at the display/input boundary.

const centsToDollars = (cents) => (typeof cents === "number" ? cents / 100 : 0);

const formatCents = (cents) => {
    if (cents === null || cents === undefined || isNaN(cents)) return "--";
    return centsToDollars(cents).toLocaleString("en-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};

// Parses a user-typed dollar amount into integer cents. Returns null for
// anything that isn't a valid non-negative amount with at most 2 decimals.
const parseDollarsToCents = (value) => {
    if (value === "" || value === null || value === undefined) return null;
    const normalised = String(value).replace(/,/g, "").trim();
    if (!/^\d+(\.\d{1,2})?$/.test(normalised)) return null;
    return Math.round(parseFloat(normalised) * 100);
};

export { centsToDollars, formatCents, parseDollarsToCents };
